import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Root, SidePanel, SidePanelContent, Title } from 'signup-components/components/SidePanelLayout/SidePanelLayout';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { View } from 'foundations-components/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { getFlowKey } from '../routing/getFlowKey';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { Step } from 'signup-constants/Step';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { isOAuthSignup } from '../app/verificationTypeSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const shouldShowIllustration = currentStep => {
  return [Step.LandingPage, Step.CodeVerification, Step.Password, Step.ResendEmail, Step.Name, Step.RecaptchaCreationError].includes(currentStep);
};
export const SidePanelLayoutViewContainer = ({
  children,
  currentStepNumber,
  customLogo,
  totalSteps
}) => {
  const {
    isDesktop
  } = useResponsiveness();
  const activeFlow = getFlowKey();
  const {
    currentStep
  } = useCurrentStep();
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const isOAuthFlow = useSelector(isOAuthSignup);
  const isPreVerificationStep = shouldShowIllustration(currentStep);
  const shouldShowIllustrationSidePanel = isPreVerificationStep || currentStep === Step.LoadingPage && !isOAuthFlow;
  const isSidePanelTitleValid = isValidI18nKey(`sidepanel.hubType.${activeFlow}.title`);
  const sidePanelActiveFlowTitle = isSidePanelTitleValid ? `sidepanel.hubType.${activeFlow}.title` : 'sidepanel.hubType.crm.title';
  return /*#__PURE__*/_jsxs(Root, {
    currentStepNumber: currentStepNumber,
    customLogo: customLogo,
    totalSteps: totalSteps,
    children: [isDesktop && /*#__PURE__*/_jsx(SidePanel, {
      children: /*#__PURE__*/_jsxs(SidePanelContent, {
        children: [shouldShowIllustrationSidePanel && /*#__PURE__*/_jsxs(View, {
          marginBlockStart: "1600",
          textAlign: "center",
          children: [/*#__PURE__*/_jsx(Illustration, {
            height: isTrellisThemeEnabled ? '136px' : '200px',
            isThemeable: true,
            name: isTrellisThemeEnabled ? 'success-green' : 'content-strategy',
            width: isTrellisThemeEnabled ? '136px' : '200px'
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockStart: isTrellisThemeEnabled ? '500' : '100',
            textAlign: "center",
            typography: "heading-400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: sidePanelActiveFlowTitle
            })
          })]
        }), !shouldShowIllustrationSidePanel && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Title, {
            message: "sidepanel.title"
          }), /*#__PURE__*/_jsx(Text, {
            color: "text-core-default",
            marginBlockStart: "600",
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "sidepanel.description"
            })
          })]
        })]
      })
    }), children]
  });
};